module.exports = __webpack_public_path__ + "img/icon-documentacion-pliego.43e6d1be.svg";